import { useLocation, Link } from "react-router-dom";
import breadcrumbConfig from "./breadcrumbConfig";
import { useEffect, useState } from "react";

const Breadcrumbs = () => {
  const location = useLocation();
  const breadcrumbs = breadcrumbConfig[location.pathname];
  const [isAstroPage, setIsAstroPage] = useState(false)
  // adjust path if needed

  useEffect(() => {

    const isAstroPage = location.pathname === "/basic-details" || location.pathname === "/numerology" || location.pathname === "/daily-panchang" || location.pathname === "/Prediction";
    setIsAstroPage(isAstroPage)
  }, [location?.pathname])


  if (!breadcrumbs || !Array.isArray(breadcrumbs)) return null;


  return (
    <nav aria-label="breadcrumb" className="my-2">
      <ol className={`breadcrumb ${isAstroPage ? 'custom-white' : 'custom-black'}`}>
        {breadcrumbs.map((crumb, idx) => {
          const isLast = idx === breadcrumbs.length - 1;

          return (
            <li
              key={idx}
              className={`breadcrumb-item  ${isLast ? "active fw-bold" : ""}`}
              {...(isLast ? { "aria-current": "page" } : {})}
              style={isLast ? { color: `${isAstroPage ? '#ff9900' : '#a52444'}`, fontSize: '18px' } : { color: `${isAstroPage ? 'white' : 'black'}`, fontSize: '18px' }}
            >

              {!isLast ? (
                crumb.path.startsWith("http") ? (
                  <a style={{ color: `${isAstroPage ? 'white' : 'black'}`, fontSize: '18px' }} href={crumb.path} target="_blank" rel="noopener noreferrer">{crumb.label}</a>
                ) : (
                  <Link style={{ color: `${isAstroPage ? 'white' : 'black'}`, fontSize: '18px' }} to={crumb.path}>{crumb.label}</Link>
                )
              ) : (
                crumb.label
              )}

            </li>
          );
        })}
      </ol>
    </nav >
  );
};

export default Breadcrumbs;
